// https://vuex.vuejs.org/en/getters.html
import { highlightLogRecordText } from '@/utils/helper'

export default {
  getLoading (state) {
    return state.loading
  },
  getFormDialogSaving (state) {
    return state.formDialogSaving
  },
  getFormDialogSuccess (state) {
    return state.formDialogSuccess
  },
  getLogRecords: (state) => {
    let logRecords = []
    if (state.changeLog.startDate && state.changeLog.endDate) {
      let startDate = window.moment(state.changeLog.startDate)
      let endDate = window.moment(state.changeLog.endDate)
      logRecords = state.changeLog.data.filter(log => window.moment(log.Create_Date) >= startDate && window.moment(log.Create_Date) <= endDate)
    } else {
      logRecords = state.changeLog.data
    }
    console.log(state.changeLog.module)
    if (!state.changeLog.module || state.changeLog.module !== 'all') {
      logRecords = logRecords.filter(log => log.Record_Module === state.changeLog.module)
    }

    if (state.changeLog.action !== 'all') {
      logRecords = logRecords.filter(log => log.action === state.changeLog.action)
    } 

    if (state.changeLog.highlight) {
      return logRecords.map(log => {
        return highlightLogRecordText(log)
      })
    }
    return logRecords
  }
}
